module.exports = __webpack_public_path__ + "static/media/kn.16bcad63.png";